Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var vIii13 = f1574(require("./krunkScriptUtils.js"));
function f1574(p12772) {
  if (p12772 && p12772.__esModule) {
    return p12772;
  } else {
    return {
      default: p12772
    };
  }
}
function f1575(p12773, p12774) {
  return f1578(p12773) || f1577(p12773, p12774) || f1585(p12773, p12774) || f1576();
}
function f1576() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function f1577(p12775, p12776) {
  var v10192 = p12775 == null ? null : typeof Symbol != "undefined" && p12775[Symbol.iterator] || p12775["@@iterator"];
  if (v10192 != null) {
    var v10193;
    var v10194;
    var vA557 = [];
    var v10195 = true;
    var v10196 = false;
    try {
      for (v10192 = v10192.call(p12775); !(v10195 = (v10193 = v10192.next()).done) && (vA557.push(v10193.value), !p12776 || vA557.length !== p12776); v10195 = true) {
        ;
      }
    } catch (e90) {
      v10196 = true;
      v10194 = e90;
    } finally {
      try {
        if (!v10195 && v10192.return != null) {
          v10192.return();
        }
      } finally {
        if (v10196) {
          throw v10194;
        }
      }
    }
    return vA557;
  }
}
function f1578(p12777) {
  if (Array.isArray(p12777)) {
    return p12777;
  }
}
function f1579(p12778) {
  return f1582(p12778) || f1581(p12778) || f1585(p12778) || f1580();
}
function f1580() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function f1581(p12779) {
  if (typeof Symbol != "undefined" && p12779[Symbol.iterator] != null || p12779["@@iterator"] != null) {
    return Array.from(p12779);
  }
}
function f1582(p12780) {
  if (Array.isArray(p12780)) {
    return f1586(p12780);
  }
}
function f1583(p12781, p12782) {
  var v10197 = typeof Symbol != "undefined" && p12781[Symbol.iterator] || p12781["@@iterator"];
  if (!v10197) {
    if (Array.isArray(p12781) || (v10197 = f1585(p12781)) || p12782 && p12781 && typeof p12781.length == "number") {
      if (v10197) {
        p12781 = v10197;
      }
      var vLN01634 = 0;
      function f1584() {}
      return {
        s: f1584,
        n: function () {
          if (vLN01634 >= p12781.length) {
            return {
              done: true
            };
          } else {
            return {
              done: false,
              value: p12781[vLN01634++]
            };
          }
        },
        e: function (p12783) {
          throw p12783;
        },
        f: f1584
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var v10198;
  var v10199 = true;
  var v10200 = false;
  return {
    s: function () {
      v10197 = v10197.call(p12781);
    },
    n: function () {
      var v10201 = v10197.next();
      v10199 = v10201.done;
      return v10201;
    },
    e: function (p12784) {
      v10200 = true;
      v10198 = p12784;
    },
    f: function () {
      try {
        if (!v10199 && v10197.return != null) {
          v10197.return();
        }
      } finally {
        if (v10200) {
          throw v10198;
        }
      }
    }
  };
}
function f1585(p12785, p12786) {
  if (p12785) {
    if (typeof p12785 == "string") {
      return f1586(p12785, p12786);
    }
    var v10202 = Object.prototype.toString.call(p12785).slice(8, -1);
    if (v10202 === "Object" && p12785.constructor) {
      v10202 = p12785.constructor.name;
    }
    if (v10202 === "Map" || v10202 === "Set") {
      return Array.from(p12785);
    } else if (v10202 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v10202)) {
      return f1586(p12785, p12786);
    } else {
      return undefined;
    }
  }
}
function f1586(p12787, p12788) {
  if (p12788 == null || p12788 > p12787.length) {
    p12788 = p12787.length;
  }
  for (var vLN01635 = 0, vArray58 = Array(p12788); vLN01635 < p12788; vLN01635++) {
    vArray58[vLN01635] = p12787[vLN01635];
  }
  return vArray58;
}
function f1587(p12789) {
  '@babel/helpers - typeof';

  f1587 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (p12790) {
    return typeof p12790;
  } : function (p12791) {
    if (p12791 && typeof Symbol == "function" && p12791.constructor === Symbol && p12791 !== Symbol.prototype) {
      return "symbol";
    } else {
      return typeof p12791;
    }
  };
  return f1587(p12789);
}
function f1588(p12792, p12793) {
  if (!(p12792 instanceof p12793)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function f1589(p12794, p12795) {
  var v10203;
  for (var vLN01636 = 0; vLN01636 < p12795.length; vLN01636++) {
    v10203 = p12795[vLN01636];
    v10203.enumerable = v10203.enumerable || false;
    v10203.configurable = true;
    if ("value" in v10203) {
      v10203.writable = true;
    }
    Object.defineProperty(p12794, v10203.key, v10203);
  }
}
function f1590(p12796, p12797, p12798) {
  if (p12797) {
    f1589(p12796.prototype, p12797);
  }
  if (p12798) {
    f1589(p12796, p12798);
  }
  Object.defineProperty(p12796, "prototype", {
    writable: false
  });
  return p12796;
}
var vF87 = function () {
  function f1591() {
    f1588(this, f1591);
  }
  f1590(f1591, null, [{
    key: "addPrefix",
    value: function (p12799) {
      if (vIii13.default.prefix.has(p12799)) {
        return p12799;
      } else {
        return vIii13.default.prefix.add(p12799);
      }
    }
  }, {
    key: "sanitize",
    value: function (p12800) {
      if (f1587(p12800) == "object") {
        if (Array.isArray(p12800)) {
          return p12800.map(function (p12801) {
            return f1591.sanitize(p12801);
          });
        }
        var vO316 = {};
        for (var v10204 in p12800) {
          var v10205 = vIii13.default.prefix.remove(v10204);
          vO316[v10205] = f1591.sanitize(p12800[v10204]);
        }
        return vO316;
      }
      if (typeof p12800 == "function") {
        return Symbol("action");
      } else {
        return p12800;
      }
    }
  }, {
    key: "prefix",
    value: function (p12802, Iìíîïìï = []) {
      if (f1587(p12802) == "object") {
        if (Array.isArray(p12802)) {
          return p12802.map(function (p12803) {
            return f1591.prefix(p12803, Iìíîïìï);
          });
        }
        var vO317 = {};
        var vIii14 = function f1592(p12804) {
          var v10206 = Object.getOwnPropertyDescriptor(p12802, p12804);
          v10206.configurable = false;
          if (vIii13.default.prefix.has(p12804)) {
            Object.defineProperty(vO317, p12804, {
              get: function f1593() {
                return p12802[p12804];
              },
              set: function f1594(p12805) {
                return p12802[p12804] = p12805;
              },
              configurable: false,
              enumerable: true
            });
            return "continue";
          } else {
            if (v10206.hasOwnProperty("value")) {
              v10206.value = f1591.prefix(v10206.value, Iìíîïìï.concat(p12804));
              if (["function", "object"].includes(f1587(v10206.value))) {
                v10206.writable = false;
              }
            }
            Object.defineProperty(vO317, vIii13.default.prefix.add(p12804), v10206);
            return;
          }
        };
        for (var v10207 in p12802) {
          var vVIii14 = vIii14(v10207);
          vVIii14 === "continue";
        }
        return new Proxy(vO317, {
          set: function f1595(p12806, p12807, p12808) {
            if (!Object.getOwnPropertyDescriptor(p12806, p12807)) {
              Object.defineProperty(p12806, p12807, {
                get: function f1596() {
                  return p12802[p12807];
                },
                set: function f1597(p12809) {
                  return p12802[p12807] = p12809;
                },
                configurable: false,
                enumerable: true
              });
            }
            p12806[p12807] = p12808;
            return true;
          }
        });
      }
      if (typeof p12802 == "function") {
        var vIi36 = function f1598() {
          try {
            return f1591.prefix(p12802.apply(undefined, arguments), Iìíîïìï);
          } catch (e91) {
            if (f1591.log) {
              console.log(e91);
            }
            throw new Error(`Internal Error "${Iìíîïìï.join(".")}"`);
          }
        };
        vIi36.origin = p12802;
        return vIi36;
      }
      return p12802;
    }
  }, {
    key: "autoCompleteList",
    value: function f1599(p12810, p12811, p12812) {
      var vA558 = [];
      if (f1587(p12810) == "object") {
        if (!Array.isArray(p12810)) {
          for (var v10208 in p12810) {
            vA558.push.apply(vA558, f1579(f1591.autoCompleteList(p12810[v10208], p12811, p12812.concat(vIii13.default.prefix.remove(v10208)))));
          }
        } else if (p12810.length) {
          var v10209;
          var vF1583 = f1583(f1591.autoCompleteList(p12810[0], p12811, p12812));
          try {
            for (vF1583.s(); !(v10209 = vF1583.n()).done;) {
              var v10210 = v10209.value;
              vA558.push({
                text: v10210.text,
                type: `${v10210.type}[]`
              });
            }
          } catch (e92) {
            vF1583.e(e92);
          } finally {
            vF1583.f();
          }
        } else {
          vA558.push({
            text: `${p12812.join(".")}${params}`,
            type: "any"
          });
        }
      } else if (typeof p12810 == "function") {
        var v10211 = /\s*(\([^\)]*\))/g.exec((p12810.origin || p12810).toString())[1].replace(/[\t\r\n]/g, " ").replace(/\s+/g, " ");
        var v10212 = false;
        for (var v10213 in p12811) {
          if (vIii13.default.wildcardToRegex(v10213).test(p12812.join("."))) {
            var v10214 = p12811[v10213];
            var vF1575 = f1575(v10214, 1);
            var v10215 = vF1575[0];
            vA558.push({
              text: `${p12812.join(".")}${v10211}`,
              type: v10215
            });
            v10212 = true;
            break;
          }
        }
        if (!v10212) {
          vA558.push({
            text: `${p12812.join(".")}${v10211}`,
            type: "action()"
          });
        }
      } else {
        vA558.push({
          text: p12812.join("."),
          type: {
            boolean: "bool",
            number: "num",
            string: "str"
          }[f1587(p12810)] || "any"
        });
      }
      if (p12812.length < 2) {
        return vA558.sort(function (p12813, p12814) {
          if (p12813.text < p12814.text) {
            return -1;
          } else {
            return 1;
          }
        });
      } else {
        return vA558;
      }
    }
  }, {
    key: "parse",
    value: function f1600(p12815, p12816, Iiìiïii = {}) {
      var v10216 = Iiìiïii.error;
      var v10217 = new Function(p12815).bind(p12816)();
      if (v10216) {
        var vO318 = {};
        var vIii15 = function f1601(p12817) {
          vO318[p12817] = function () {
            try {
              return v10217[p12817].apply(v10217, arguments);
            } catch (e93) {
              v10216(e93.message);
            }
          };
        };
        for (var v10218 in v10217) {
          vIii15(v10218);
        }
        return vO318;
      }
      return v10217;
    }
  }, {
    key: "minify",
    value: function f1602(p12818) {
      return p12818.replace(/^\s*#[^\r\n]+[\r\n]/gm, "").replace(/\s+/g, " ").replace(/\s?([^\w])\s?/g, "$1").replace(/(public )?((bool|num|str|obj) )?action \w+\([\w\s,]*\){}/g, "").trim();
    }
  }]);
  return f1591;
}();
exports.default = vF87;